const getAllMailTemplate = (store) => {
    let payload = {
        query: 'page=1&limit=999',
        successCallback: (response) => {
            return response.data?.data?.data_list ?? [];
        },
        errorCallback: () => {
            return [];
        }
    };
    return store.dispatch('mail/list', payload);
};
export { getAllMailTemplate };
